import {
  AlertTriangle,
  ArrowLeftRight,
  BadgeCheck,
  FileStack,
  FileText,
  FolderTree,
  Gavel,
  Landmark,
  ListOrdered,
  Mail,
  MessagesSquare,
  NotebookPen,
  PencilLine,
  Quote,
  Scale,
  Scissors,
  ScrollText,
  ShieldCheck,
  Table,
  Users,
  type LucideIcon,
} from 'lucide-react';
import type { NativeQuickActionKey } from '@hector/shared-types/quick-actions';
import type { UserPrompt } from '../../api/userPrompts.api';

/**
 * Icône des actions natives Hector, indexée par clé permanente et non par
 * titre : le titre d'une native vient du catalogue et peut évoluer.
 */
const NATIVE_QUICK_ACTION_ICONS: Record<NativeQuickActionKey, LucideIcon> = {
  'redact-assignation': Gavel,
  'redact-conclusions-replique': Scale,
  'redact-acte': FileText,
  'organize-pieces': FolderTree,
  'generate-bordereau-from-act': FileStack,
  'renumber-pieces': ListOrdered,
  'rename-pieces': PencilLine,
  'split-pdf': Scissors,
  'compare-with-case': ArrowLeftRight,
  'reuse-argument-from-case': Quote,
  'client-cases-overview': Users,
};

/**
 * Icône spécifique par titre pour les 8 prompts par défaut du catalogue
 * backend (`CASEDISCOVERY_DEFAULTS`) — évite l'icône générique unique que
 * l'avocat trouvait "trop IA" (retour du 2026-09-09). Un prompt personnalisé
 * (titre hors catalogue) retombe sur l'icône générique NotebookPen.
 */
const DEFAULT_PROMPT_ICONS: Record<string, LucideIcon> = {
  'Synthèse du dossier': ScrollText,
  'Arguments pour mon client': ShieldCheck,
  'Rédiger un mail client': Mail,
  'Répondre aux arguments adverses': MessagesSquare,
  'Tableau récapitulatif des pièces': Table,
  'Rechercher de la jurisprudence': Landmark,
  'Vérifier mes sources': BadgeCheck,
  'Points de vigilance': AlertTriangle,
};

function isNativeIconKey(key: string): key is NativeQuickActionKey {
  return key in NATIVE_QUICK_ACTION_ICONS;
}

export function iconForPrompt(prompt: Pick<UserPrompt, 'title' | 'native_key'>): LucideIcon {
  if (prompt.native_key && isNativeIconKey(prompt.native_key)) {
    return NATIVE_QUICK_ACTION_ICONS[prompt.native_key];
  }
  return DEFAULT_PROMPT_ICONS[prompt.title] ?? NotebookPen;
}
